var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 61,
    viewBox: "0 0 95 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47687 13.7552C5.60657 11.5068 7.46767 9.75 9.71987 9.75H34.2801C36.5323 9.75 38.3934 11.5068 38.5231 13.7552L41.1292 58.928C41.1706 59.6455 40.5999 60.25 39.8813 60.25H4.11867C3.40007 60.25 2.82937 59.6455 2.87077 58.928L5.47687 13.7552Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_4361",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 31,
    width: 26,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41992 32.5273C9.41992 31.975 9.86762 31.5273 10.4199 31.5273H33.6831C34.2354 31.5273 34.6831 31.975 34.6831 32.5273V52.6325C34.6831 53.1848 34.2354 53.6325 33.6831 53.6325H10.4199C9.86762 53.6325 9.41992 53.1848 9.41992 52.6325V32.5273Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_4361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41992 32.5273C9.41992 31.975 9.86762 31.5273 10.4199 31.5273H33.6831C34.2354 31.5273 34.6831 31.975 34.6831 32.5273V52.6325C34.6831 53.1848 34.2354 53.6325 33.6831 53.6325H10.4199C9.86762 53.6325 9.41992 53.1848 9.41992 52.6325V32.5273Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 37.0938H32.8806",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 42.3555H32.8806",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 47.6172H32.8806",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0527 6.2632V1",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6316 6.26128L11.5264 2.05078",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2105 8.26337L1 5.10547",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8926 8.26337L42.0505 5.10547",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4736 6.26128L32.5789 2.05078",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4727 13.6328H32.8411C33.9456 13.6328 34.8411 14.5283 34.8411 15.6328V21.0013",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25.75H5",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 18.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0002 40.8008C80.0002 40.8008 86.6668 37.8008 86.6668 33.3008V28.0508L80.0002 25.8008L73.3335 28.0508V33.3008C73.3335 37.8008 80.0002 40.8008 80.0002 40.8008Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3332 31.1992L78.7498 35.3242L76.6665 33.4492",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon7);
export default __webpack_public_path__ + "static/media/faq-icon7.a342e4313a7133f51b7e77fb2a8a359e.svg";
export { ForwardRef as ReactComponent };